export default "__VITE_ASSET__271218b0__"